// src/pages/OrderConfirmation.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getOrder } from "../utils/firestoreService";

export default function OrderConfirmation() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => { getOrder(id).then(setOrder); }, [id]);

  const formatPrice = p =>
    new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 }).format(p);

  return (
    <div className="confirmation-page page-pad">
      <div className="confirm-card">
        <div className="confirm-icon">✅</div>
        <h1>¡Pedido confirmado!</h1>
        <p>Gracias por tu compra. Recibirás un correo con los detalles.</p>
        <div className="order-id">Pedido # <strong>{id.slice(0, 8).toUpperCase()}</strong></div>

        {order && (
          <>
            <div className="confirm-info">
              <div><strong>Cliente:</strong> {order.customer?.name}</div>
              <div><strong>Email:</strong> {order.customer?.email}</div>
              <div><strong>Envío a:</strong> {order.shipping?.address}, {order.shipping?.city}, {order.shipping?.department}</div>
              <div><strong>Total:</strong> {formatPrice(order.total)}</div>
            </div>

            <div className="confirm-items">
              {order.items?.map((item, i) => (
                <div key={i} className="confirm-item">
                  <span>{item.name}</span>
                  <span>x{item.quantity}</span>
                  <span>{formatPrice(item.price * item.quantity)}</span>
                </div>
              ))}
            </div>
          </>
        )}

        {order?.paymentMethod === "transferencia" && (
          <div className="transfer-reminder">
            <h3>⚠️ Recuerda enviar tu comprobante</h3>
            <p>Envía el comprobante de pago a <a href="mailto:pagos@conelcorazon.co">pagos@conelcorazon.co</a> indicando tu número de pedido para procesar el envío.</p>
          </div>
        )}

        <div className="confirm-next">
          <h3>¿Qué sigue?</h3>
          <ol>
            <li>Confirmaremos tu pedido en menos de 24 horas</li>
            <li>Produciremos tu artículo con amor (2-5 días hábiles)</li>
            <li>Lo enviaremos a tu dirección (3-7 días)</li>
            <li>¡Disfruta tu pieza única!</li>
          </ol>
        </div>

        <div className="confirm-actions">
          <Link to="/tienda" className="btn-primary">Seguir comprando</Link>
          <a
            href="https://wa.me/573000000000"
            target="_blank" rel="noreferrer"
            className="btn-ghost"
          >Preguntas por WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
